<template>
  <div class="flex flex-column items-center w-100 h-100 overflow-y-scroll">
    <div class="mw9-ns w-100">
      <div class="flex flex-wrap w-100">
        <div class="w-two-thirds-l w-100">
          <latest-news/>
        </div>
        <div class="w-third-l w-100 flex flex-column">
          <vinyl-contest-home/>
          <banner/>
        </div>
      </div>
      <div class="flex flex-wrap w-100">
        <div class="w-two-thirds-l w-100">
          <featured-playlist/>
        </div>
        <div class="w-third-l w-100 flex flex-column">
          <recommended/>
        </div>
      </div>
    </div>
    <home-footer/>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'

  import VinylContestHome from './VinylContestHome.vue'
  import Recommended from './Recommended.vue'
  import FeaturedPlaylist from './FeaturedPlaylist.vue'
  import LatestNews from './LatestNews.vue'
  import Banner from './Banner.vue'
  import HomeFooter from './HomeFooter.vue'

  export default {
    name: 'home-list',
    components: {
      VinylContestHome,
      Recommended,
      LatestNews,
      FeaturedPlaylist,
      Banner,
      HomeFooter
    },
    created () {
      this.providerLogin()
      if (this.$route.query.playlist_id) {
        this.$router.push({name: 'playlist', params: { id: this.$route.query.playlist_id }})
      }
    },
    methods: {
      ...mapActions('user', [
        'loginByMsisdn'
      ]),
      providerLogin () {
        /*
        if (this.$route.query.xmsisdn) {
          this.loginByMsisdn({msisdn: this.$route.query.xmsisdn, provider: 'movistar', enc: true}).then((e) => {
          }).catch(() => {
          })
        }
        */
      }
    }
  }
</script>

<style scoped lang="scss">
  @import '~@/variables.scss';

  .content-card {
    // min-width: 30%;
    min-height: 20%;
    // max-width: 300px;
    max-width: 60%;
    max-height: 70%;
  }

  .home-container {
    max-width: 90%;
  }

  @media (max-width: 768px) {
    .banner-logo{
      margin:0;
    }
  }
  @media (max-width: 479px) {
    .go-to-news-icon {
      margin-bottom: 1px;
      margin-left: 1px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home/HomeList.vue